exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-progress-circular[data-v-74df1bbb] {\n  margin: 1rem;\n}\n", ""]);

// exports
